export const cmtsKeys = {
  all: ["cmts"] as const,
  auth: () => ["cmts", "auth"] as const,
  references: (tenantId?: string) => ["cmts", "references", tenantId] as const,
  complaints: (tenantId?: string) => ["cmts", "complaints", tenantId] as const,
  complaintDetail: (id: string, tenantId?: string) => ["cmts", "complaints", id, tenantId] as const,
  workflowActions: (id: string, tenantId?: string) => ["cmts", "workflow", id, tenantId] as const,
  evidence: (id: string, tenantId?: string) => ["cmts", "evidence", id, tenantId] as const,
  rca: (id: string, tenantId?: string) => ["cmts", "rca", id, tenantId] as const,
  capa: (id: string, tenantId?: string) => ["cmts", "capa", id, tenantId] as const,
  verification: (id: string, tenantId?: string) => ["cmts", "verification", id, tenantId] as const,
  sla: (tenantId?: string) => ["cmts", "sla", tenantId] as const,
  tasks: (tenantId?: string) => ["cmts", "tasks", tenantId] as const,
  notifications: (tenantId?: string) => ["cmts", "notifications", tenantId] as const,
  dashboards: (type: string, tenantId?: string) => ["cmts", "dashboards", type, tenantId] as const,
  reports: (code: string, tenantId?: string) => ["cmts", "reports", code, tenantId] as const,
  configuration: (tenantId?: string) => ["cmts", "configuration", tenantId] as const,
  dependencies: (tenantId?: string) => ["cmts", "dependencies", tenantId] as const,
  audit: (tenantId?: string) => ["cmts", "audit", tenantId] as const,
};
